module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.action !== 'create') ? _c('div', {
    staticClass: "w5-component-field-title"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.action !== 'create' && _vm.Groups && _vm.Groups.length > 1) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper plan"
  }, [_c('div', {
    staticClass: "w5-vds-plan-list-block"
  }, _vm._l((_vm.Groups), function(group) {
    return _c('div', {
      key: group.id,
      staticClass: "w5-vds-plan-list-item groups",
      class: {
        'selected': group.id == _vm.curGroup, 'not-active-item': group.active === false
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onGroupClick(group)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up"
    }, [_c('img', {
      staticClass: "local-group",
      attrs: {
        "src": _vm.APIServerUrl + group.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "w5-vds-plan-list-item-down"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")(group.name)))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.groupDescription)),
      expression: "localeFtc(groupDescription)"
    }]
  })])]) : [(_vm.action !== 'create') ? _c('div', {
    staticClass: "margin-top-5"
  }) : _c('div', {
    staticClass: "margin-top-30"
  })], _vm._v(" "), _c('div', {
    staticClass: "w5-vds-plan-list-block"
  }, [_vm._l((_vm.Items), function(item) {
    return [(item && item.id && item.params && _vm.params && _vm.params[item.id]) ? _c('div', {
      staticClass: "construct-plan",
      class: {
        'disabled': item.enable === false || !_vm.isPlanSupportedByTemplate(item.id), 'in-view': _vm.action === 'view'
      }
    }, [_c('div', {
      staticClass: "fields-values"
    }, [_vm._l((_vm.params[item.id]), function(obj, prop) {
      return [_c('div', {
        key: prop,
        staticClass: "w5-vds-plan-list-params-item"
      }, [(obj.type === 'slider') ? [_c('div', {
        staticClass: "graph-slider"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm._f("ftc")(obj.title)))]), _vm._v(" "), _c('div', {
        staticClass: "text-slider"
      }, [_c('div', {
        staticClass: "text-slider-field-wrapper"
      }, [_c('input', {
        ref: 'field-' + obj.__prop,
        refInFor: true,
        staticClass: "slider-input-field",
        attrs: {
          "type": "text",
          "data-item-id": item.id,
          "data-obj": obj.__prop,
          "disabled": item.enable === false || !_vm.isPlanSupportedByTemplate(item.id)
        },
        domProps: {
          "value": _vm.inputFieldValues[obj.__prop]
        },
        on: {
          "blur": function($event) {
            return _vm.onSliderFieldBlurNew(obj.__prop, item.id)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "field-postfix-wrapper"
      }, [_c('span', [_vm._v(_vm._s(_vm.calculatorFormatingFieldFor(obj)))])])]), _vm._v(" "), (_vm.inputFieldErrors[obj.__prop]) ? _c('div', {
        staticClass: "text-slider-field-error"
      }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.inputFieldErrors[obj.__prop])) + "\r\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "slider"
      }, [_c('vue-slider', {
        ref: 'slider-' + obj.__prop,
        refInFor: true,
        attrs: {
          "min": obj.__realMin <= 0 ? 0 : 1,
          "max": obj.max,
          "duration": 0.2,
          "marks": obj.marks,
          "interval": obj.step,
          "tooltip": "none",
          "disabled": item.enable === false || !_vm.isPlanSupportedByTemplate(item.id),
          "labelStyle": {
            fontSize: '9px',
            fontWeight: 300,
            color: '#666',
            top: '2px'
          }
        },
        on: {
          "dragging": function($event) {
            _vm.manualSliderChanged = false
          },
          "change": function (value) { return _vm.sliderDragging(item, obj, value); }
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var innerValue = ref.value;

            return [_c('div', {
              staticClass: "process-minimum",
              style: (_vm.minRangeWidthStyle(obj))
            })]
          }
        }], null, true),
        model: {
          value: (obj.value),
          callback: function($$v) {
            _vm.$set(obj, "value", $$v)
          },
          expression: "obj.value"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "cost"
      }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(obj.cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / 1 " + _vm._s(obj.for) + "\r\n\t\t\t\t\t\t\t\t\t")])])] : _vm._e(), _vm._v(" "), (obj.type === 'boolean') ? [_c('div', {
        staticClass: "checkbox params"
      }, [_c('div', {
        staticClass: "w5-boolean-field-wrapper"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (obj.value),
          expression: "obj.value"
        }],
        staticClass: "w5-checkbox-field",
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(obj.value) ? _vm._i(obj.value, null) > -1 : (obj.value)
        },
        on: {
          "change": function($event) {
            var $$a = obj.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(obj, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(obj, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(obj, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "w5-boolean-label construct-label",
        on: {
          "click": function($event) {
            return _vm.booleanChangeHandler(item, obj)
          }
        }
      }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(obj.title)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t"), (obj.hint) ? [_c('span', {
        staticClass: "hidden-xs params-boolean-hint"
      }, [_vm._v(_vm._s(_vm._f("ftc")(obj.hint)))]), _vm._v(" "), _c('div', {
        staticClass: "visible-xs params-boolean-hint"
      }, [_vm._v(_vm._s(_vm._f("ftc")(obj.hint)))])] : _vm._e()], 2)])])] : _vm._e()], 2)]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "itogo-values"
    }, [_c('div', {
      staticClass: "values"
    }, [(String(item.cost) == String(item.full_cost)) ? _c('div', {
      staticClass: "itog-item base-cost"
    }, [_c('div', {
      staticClass: "itog-item-base-cost"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm._f("ftc")((item.description || item.text))))]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('span', {
      staticClass: "sm"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.cost) + "\r\n\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\r\n\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), (_vm.action === 'create' && item && item.data) ? _c('div', {
      staticClass: "w5-vds-plan-list-params-base"
    }, [_c('div', {
      staticClass: "values"
    }, _vm._l((_vm.planBaseValues(item)), function(item, name, idx) {
      return _c('span', {
        key: 'base-values' + idx
      }, [(idx > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("ftc")(item.title)) + " " + _vm._s(item.value) + " " + _vm._s(_vm.calculatorFormatingFieldFor(item)))])
    }), 0)]) : _vm._e()]) : _c('div', {
      staticClass: "itog-item base-cost"
    }, [_c('div', {
      staticClass: "itog-item-base-cost"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm._f("ftc")((item.description || item.text))))]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('span', {
      staticClass: "sm"
    }, [_c('span', {
      staticClass: "full-cost"
    }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(item.full_cost)) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item.cost)))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\r\n\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), (_vm.action === 'create' && item && item.data) ? _c('div', {
      staticClass: "w5-vds-plan-list-params-base"
    }, [_c('div', {
      staticClass: "values"
    }, _vm._l((_vm.planBaseValues(item)), function(item, name, idx) {
      return _c('span', {
        key: 'base-values' + idx
      }, [(idx > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("ftc")(item.title)) + " " + _vm._s(item.value) + " " + _vm._s(_vm.calculatorFormatingFieldFor(item)))])
    }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.isVisibleAnyParamsItog(_vm.params[item.id])) ? _c('div', {
      staticClass: "itog-item add-cost"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/additionally')) + ":\r\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.params[item.id]), function(obj, prop) {
      return [(_vm.isVisibleParamsItog(obj)) ? _c('div', {
        staticClass: "itog-item"
      }, [_c('div', {
        staticClass: "title"
      }, [(obj.type === 'boolean') ? [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(obj.st_name)) + " " + _vm._s(Number(obj.value)) + " " + _vm._s(_vm._f("ftc")(obj.for ? _vm.calculatorFormatingFieldFor(obj) : 'main/sht')) + "\r\n\t\t\t\t\t\t\t\t\t")] : [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(obj.st_name)) + " " + _vm._s(Number(obj.value) - obj.__initMin) + " " + _vm._s(_vm._f("ftc")(obj.for ? _vm.calculatorFormatingFieldFor(obj) : 'main/sht')) + "\r\n\t\t\t\t\t\t\t\t\t")]], 2), _vm._v(" "), _c('div', {
        staticClass: "value"
      }, [(_vm.isDiscountParam(obj)) ? [(obj.type === 'slider') ? _c('span', {
        staticClass: "sm"
      }, [_c('span', {
        staticClass: "full-cost"
      }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")((Number(obj.value) - obj.__initMin) <= 0 ?
        0 :
        (Number(obj.value) - obj.__initMin) * obj.full_cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")((Number(obj.value) - obj.__initMin) <= 0 ?
        0 :
        (Number(obj.value) - obj.__initMin) * obj.cost)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(obj.period_name)))]) : _vm._e(), _vm._v(" "), (obj.type === 'boolean') ? _c('span', {
        staticClass: "sm"
      }, [(obj.value) ? [_c('span', {
        staticClass: "full-cost"
      }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(obj.full_cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(obj.cost)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(obj.period_name)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t")] : _c('span')], 2) : _vm._e()] : [(obj.type === 'slider') ? _c('span', {
        staticClass: "sm"
      }, [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")((Number(obj.value) - obj.__initMin) <= 0 ?
        0 :
        (Number(obj.value) - obj.__initMin) * obj.cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(obj.period_name)))]) : _vm._e(), _vm._v(" "), (obj.type === 'boolean') ? _c('span', {
        staticClass: "sm"
      }, [(obj.value) ? [_vm._v("\r\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(obj.cost)) + " "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(_vm._f("ftc")(obj.period_name)) + "\r\n\t\t\t\t\t\t\t\t\t\t\t")] : _c('span')], 2) : _vm._e()]], 2)]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "itogo"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v(_vm._s(_vm._f("ftc")('chart/total')) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [(_vm.isDiscountPlan(item)) ? [_c('span', {
      staticClass: "full-cost"
    }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(_vm.paramsPlanItogo(item, 'full_cost'))) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(_vm.paramsPlanItogo(item))))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\r\n\t\t\t\t\t\t\t")] : [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(_vm.paramsPlanItogo(item))) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")(item.period_name)) + "\r\n\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(30.0 * _vm.paramsPlanItogo(item, 'cost', false))) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" / " + _vm._s(_vm._f("ftc")('main/month')) + "\r\n\t\t\t\t\t\t\t")]], 2)])])]) : (item['data']) ? [_c('div', {
      key: item.id,
      staticClass: "w5-vds-plan-list-item",
      class: {
        'selected': item.id == _vm.curValue,
          'disabled': item.enable === false || !_vm.isPlanSupportedByTemplate(item.id),
          'w5-vds-plan-not-active': !_vm.isItemActive(item)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onItemClick(item.id, item.enable, item)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up"
    }, [(_vm.planAdditionalText(item)) ? [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.planAdditionalText(item))))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.planAdditionalTextFor(item))) + "\r\n\t\t\t\t\t\t\t"), _c('br')] : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['data']['cpu']['value'])) + " " + _vm._s(_vm._f("ftc")(item['data']['cpu']['for'])))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['data']['cpu']['title'])) + "\r\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['data']['ram']['value'])) + " " + _vm._s(_vm._f("ftc")(item['data']['ram']['for'])))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['data']['ram']['title'])) + "\r\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['data']['disk']['value'])) + " " + _vm._s(_vm._f("ftc")(item['data']['disk']['for'])))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['data']['disk']['title'])) + "\r\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['data']['traff']['value'])) + " " + _vm._s(_vm._f("ftc")(item['data']['traff']['for'])))]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['data']['traff']['title'])) + "\r\n\t\t\t\t\t")], 2), _vm._v(" "), _c('div', {
      staticClass: "w5-vds-plan-list-item-down"
    }, [(_vm.isDiscountPlan(item)) ? [_c('strong', [_c('span', {
      staticClass: "full-cost"
    }, [_vm._v(" " + _vm._s(_vm._f("moneyOnlyNumbers")(item['full_cost'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    }), _vm._v(" ")]), _vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['cost'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['period_name'])) + "\r\n\t\t\t\t\t\t")] : [_c('strong', [_vm._v(_vm._s(_vm._f("moneyOnlyNumbers")(item['cost'])) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
      }
    })]), _vm._v(" / " + _vm._s(_vm._f("ftc")(item['period_name'])) + "\r\n\t\t\t\t\t\t")]], 2)])] : _vm._e()]
  })], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f2987f0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/planNew.vue
// module id = 361
// module chunks = 0